<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <appl-menu-icon
          :propsParam="{
            applCd: '11',
          }"
        ></appl-menu-icon>
        {{ $t('제증명신청서 종류를 선택해주세요') }}
      </v-col>
    </v-row>

    <!-- 제증명신청서 종류 -->
    <v-list>
      <v-list-item-group color="primary">
        <v-list-item
          v-for="(item, i) in menuList"
          :key="i"
          class="gntType-item"
        >
          <v-list-item-content @click="selectMenu(item)">
            <v-list-item-title>{{ item.codeNm }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>
<script>
import ApplMenuIcon from '@/components/application/form/ApplMenuIcon.vue';

import { getCertiApplCdList } from '@/api/application';
import { mapMutations } from 'vuex';

/** 제증명 신청서 종류 선택 */
export default {
  data: () => ({
    menuList: [],
  }),

  methods: {
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),
    ...mapMutations('ELA', ['SET_APP_MENU']),

    /* 신청서 선택 */
    async selectMenu(menu) {
      // 신청서종류 선택
      const routerName = await this.$store.dispatch(
        'ELA/FETCH_CERTI_MENU_ACTION',
        {
          applCd: menu.applCd,
          applNm: menu.codeNm,
        },
      );

      this.$router.push(routerName);
    },

    /* 제증명 종류 조회 */
    async fetchCertiTypeMenu() {
      const doNotUse = ['16', '18', '19', '20', '21']; // (25.5.9) 현재는 모바일에서 원천징수영수증, 원천징수부, 해외근무증명서, 징계내역서, 갑근세증명원 미사용
      // ** 추후 추가시 수정할것!

      try {
        const response = await getCertiApplCdList({
          comboViewYn: 'Y',
          useYn: 'Y',
        });

        this.menuList = response.data.data
          .filter(item => !doNotUse.includes(item.code))
          .map(item => {
            return {
              ...item,
              applCd: item.code,
            };
          });

        this.OFF_APP_SPINNER();
      } catch (error) {
        console.log(error);
      }
    },
  },

  mounted() {
    this.ON_APP_SPINNER(); // 스피너 ON

    // 초기 데이터 조회
    this.fetchCertiTypeMenu();
  },
  components: {
    ApplMenuIcon,
  },
};
</script>
<style>
.row.title-wrap {
  margin-bottom: 10px;
}
.chip-wrap {
  padding: 0px 22px 20px;
}
.gntType-item {
  padding-left: 54px;
  padding-right: 54px;
}
.divider::before {
  margin: 0 10px;
}
</style>
